import angular from 'angular';
import OrderFilterModule from './orderFilter/OrderFilterModule';


export default angular
  .module('app.main.components', [
    OrderFilterModule,
  ])
  .name;
